module.exports = __webpack_public_path__ + "img/ETH.d91f74f9.svg";